import {BETSLIP_ADD, BETSLIP_TOGGLE_EVENT, MAKE_QUICK_BET, BETSLIP_SET_TYPE, BETSLIP_ADD_COMPARE_EVENT, BETSLIP_TOGGLE_HORSE_EVENT} from "../actions/actionTypes";
import Config from "../../dev/config/conf";
import {OpenPopup} from "../actions/ui";
import {BetslipAdd, BetslipPlaceBet, BetslipRemove, changeHorseEventType, UkBetslipPlaceBet, changeTypeToForCastOrTriCast} from "../actions/betslip";
import {createBetslipEventObject, BETSLIP_TYPE_SINGLE} from "../helpers/sport/betslip";
import cookie from "react-cookie";
import { t } from "../../dev/helpers/translator";

export const typesMap = {
    'tricast': 43,
    'forecast': 40
};

const temp = ['forecast$1', 'forecast$2', 'tricast$1', 'tricast$2', 'tricast$3'];

export function isInclude (type) {
    return temp.includes(type);
}

export function typeIsForCastOrTriCast (type = '') {
    const [firstType] = type.split('$');
    return (firstType === 'tricast' || firstType === 'forecast') ? firstType : '';
}

const setOrder = (events) => {
    let max = 0;
    Object.values(events).forEach((event) => {
        max = event.order > max ? event.order : max;
    });
    return ++max;
};
const setChronologicalOrder = (timestamp) => {
    return timestamp;
};

const betSlipUpdateHandler = store => next => action => {
    let state = store.getState(),
        betSlipEvents = state.betslip && state.betslip.events && Object.keys(state.betslip.events).length;
    const maxSelectionsInMultipleBet = state.swarmConfigData?.partner?.max_selections_in_multiple_bet;
    const openRestrictedEventsPopup = (bodyText) => {
        store.dispatch(OpenPopup("message", {
            title: t("Warning"),
            type: "warning",
            body: t(bodyText)
        }));
    };

    switch (action.type) {
        case BETSLIP_SET_TYPE:
            if (action.betSlipType === 2 && maxSelectionsInMultipleBet === 0){
                return next(action);
            }
            if (action.betSlipType === 3 && (betSlipEvents > Config.main.hasBetSlipEventsLimit)) {
                return openRestrictedEventsPopup(t("Max number of events in System bets is ") + Config.main.hasBetSlipEventsLimit);
            } else if (Config.main.disableBetSlipSingleTypeMoreTwo && action.betSlipType === 1 && betSlipEvents > 1) {
                return openRestrictedEventsPopup(t(`Max number of events in Single bets is 1`));
            } else if (action.betSlipType === 2 && (betSlipEvents > maxSelectionsInMultipleBet)) {
                return openRestrictedEventsPopup(t("Max number of events in Multiple bets is ") + maxSelectionsInMultipleBet);
            } else {
                return next(action);
            }
        case BETSLIP_ADD: {
            if (state.betslip.type === 2 && maxSelectionsInMultipleBet === 0 ) {
                return next(action);
            }
            if (state.betslip.type === 2 && (betSlipEvents >= maxSelectionsInMultipleBet)) {
                return openRestrictedEventsPopup(t("Max number of events in Multiple bets is ") + maxSelectionsInMultipleBet);
            }
            if (Config.main.hasBetSlipEventsLimit && (betSlipEvents >= Config.main.hasBetSlipEventsLimit)) {
                switch (true) {
                    case Config.main.enableUkBetslip:
                        return openRestrictedEventsPopup(t("Max number of events that can be added to Betslip is ") + Config.main.hasBetSlipEventsLimit);
                    case state.betslip.type === 3:
                        return openRestrictedEventsPopup(t("Max number of events in System bets is ") + Config.main.hasBetSlipEventsLimit);
                    default:
                        return next(action);
                }
            }
            return next(action);
        }
        case BETSLIP_TOGGLE_HORSE_EVENT: {
            const { [action.payload.id]: { type } = {} } = state.betslip.horseEvents;
            if (type === action.payload.type) { //eslint-disable-line react/prop-types
                return next(BetslipRemove(action.payload.id, true));
            }
            const firstType = typeIsForCastOrTriCast(action.payload.type);
            if (Object.keys(state.betslip.events).length > 0) {
                const firstEventInHorseEvent = state.betslip.horseEvents[Object.keys(state.betslip.horseEvents)[0]];
                if ([40, 43].includes(state.betslip.type) &&
                (state.betslip.type !== typesMap[firstType] ||
                action.payload.gameId !== firstEventInHorseEvent.gameId)) {
                    return next(OpenPopup("errorPopup", {errorMessage: 'BetSlip is not empty, please release it before adding a new bet to it.'}));
                }
                if ([40, 43].includes(typesMap[firstType]) && Object.keys(state.betslip.horseEvents)
                    .map(item => state.betslip.horseEvents[item].type)
                    .filter(item => isInclude(item))
                    .includes(action.payload.type)) {
                    return next(OpenPopup("errorPopup", {errorMessage: 'BetSlip is not empty, please release it before adding a new bet to it.'}));
                }
                if ([40, 43].includes(typesMap[firstType]) && Object.keys(state.betslip.horseEvents)
                    .map(item => state.betslip.horseEvents[item].type)
                    .every(item => isInclude(item)) !== isInclude(action.payload.type)) {
                    return next(OpenPopup("errorPopup", {errorMessage: 'BetSlip is not empty, please release it before adding a new bet to it.'}));
                }
                // BETSLIP_TOGGLE_HORSE_EVENT work only if horse event toggle
                // SP and Price not conflict with others events but work in BETSLIP_TOGGLE_HORSE_EVENT
                if ([40, 43].includes(typesMap[firstType]) && state.betslip.type !== typesMap[firstType]) {
                    return next(OpenPopup("errorPopup", {errorMessage: 'BetSlip is not empty, please release it before adding a new bet to it.'}));
                }
            }
            if (typesMap[firstType]) {
                next(changeTypeToForCastOrTriCast(typesMap[firstType]));
            }
            if (Config.main.enableUkBetslip || Config.main.disableMultipleSingleBets) {
                let events = Object.values(state.betslip.horseEvents).sort((a, b) => a.order - b.order); //eslint-disable-line react/prop-types
                if (events && events.length && !firstType) {
                    events.forEach(event => {
                        if (event.gameId.toString() === action.payload.gameId.toString()) {
                            next(BetslipRemove(event.eventId, true));
                        }
                    });
                }
            }
            return next(changeHorseEventType(action.payload.id, action.payload.type, action.payload.gameId));
        }
        case BETSLIP_TOGGLE_EVENT: {
            let betslipEvents = state.betslip.events,
                { game, market, event, sportType, isBoosted } = action.meta;

            if (state.betslip.events[action.payload] !== undefined) { //eslint-disable-line react/prop-types
                if (sportType !== 'HORSE' && !state.betslip.horseEvents[action.payload]) {
                    return next(BetslipRemove(action.payload));
                }
            }
            if (sportType === 'HORSE' && !state.betslip.horseEvents[action.payload]) {
                return;
            }
            // if horse event fist work BETSLIP_TOGGLE_HORSE_EVENT and it change changeTypeToForCastOrTriCast
            // thats why we check state.betslip.horseEvents[action.payload] === undefined
            if (state.betslip.horseEvents[action.payload] === undefined && [40, 43].includes(state.betslip.type)) {
                return next(OpenPopup("errorPopup", {errorMessage: 'BetSlip is not empty, please release it before adding a new bet to it.'}));
            }
            let newEvent = createBetslipEventObject(game, market, event, sportType, isBoosted, !Config.enableOrderInBetslip ? setOrder(betslipEvents) : setChronologicalOrder(game.start_ts)); //eslint-disable-line react/prop-types
            if (Config.main.enableUkBetslip || Config.main.disableMultipleSingleBets) {
                let events = Object.values(betslipEvents).sort((a, b) => a.order - b.order); //eslint-disable-line react/prop-types
                if (events && events.length && sportType !== 'HORSE') {
                    events.forEach(event => {
                        if ((event.gameId.toString() === newEvent.gameId.toString()) &&
                            (((event.expressId && newEvent.expressId && (event.expressId.toString() === newEvent.expressId.toString())) ||
                            event.expressId === undefined || newEvent.expressId === undefined))) {
                            newEvent.order = event.order;
                            next(BetslipRemove(event.eventId));
                        }
                    });
                }
            }
            if (Object.keys(state.betslip.events).length > 0 && Config.main.indoAndMalayToHongkong) {
                cookie.remove("oddsChangedManually");
            }
            store.dispatch(BetslipAdd(newEvent));
            return next(action);
        }
        case BETSLIP_ADD_COMPARE_EVENT: {
            if (state.betslip.events[action.payload] !== undefined) { //eslint-disable-line react/prop-types
                return next(action);
            }
            if (Config.enableBoostedOdds && state.terminal.boostedOddsGameIds && state.terminal.boostedOddsGameIds[action.meta.game.id] && state.terminal.boostedOddsGameIds[action.meta.game.id].length > 0) {
                let boostedOddsGame = state.terminal.boostedOddsGameIds[action.meta.game.id];
                var isBoostedGame = {};
                for (let item of boostedOddsGame) {
                    var tempObj = {
                        ...tempObj,
                        [item.Id]: {
                            Id: item.Id,
                            marketId: item.MarketId,
                            name: item.Name,
                            marketName: item.MarketName,
                            MatchId: item.MatchId
                        }
                    };
                    isBoostedGame = tempObj;
                }
            }
            let isBoosted = isBoostedGame && !!isBoostedGame[action.meta.event.id];
            let betslipEvents = state.betslip.events,
                {game, market, event} = action.meta,
                newEvent = createBetslipEventObject(game, market, event, null, isBoosted, !Config.enableOrderInBetslip ? setOrder(betslipEvents) : setChronologicalOrder(game.start_ts)); //eslint-disable-line react/prop-types
                if (Config.main.enableUkBetslip || Config.main.disableMultipleSingleBets) {
                let events = Object.values(betslipEvents).sort((a, b) => a.order - b.order); //eslint-disable-line react/prop-types
                if (events && events.length) {
                    events.every(event => {
                        if ((event.gameId.toString() === newEvent.gameId.toString()) && ((event.expressId && newEvent.expressId && (event.expressId.toString() === newEvent.expressId.toString())) || event.expressId === undefined || newEvent.expressId === undefined)) {
                            newEvent.order = event.order;
                            return next(BetslipRemove(event.eventId));
                        }
                        return true;
                    });
                }
            }
            if (Object.keys(state.betslip.events).length > 0 && Config.main.indoAndMalayToHongkong) {
                cookie.remove("oddsChangedManually");
            }
            store.dispatch(BetslipAdd(newEvent));
            return next(action);
        }
        case MAKE_QUICK_BET: {
            let {betterOddSelectionMode, acceptPriceChanges, eachWayMode, freeBet, stake, quickBet, multipleOptions} = state.betslip,
                {bet} = action.meta,
                eventId = action.payload;

            bet.singleStake = stake;
            let betData = {
                type: BETSLIP_TYPE_SINGLE,
                betterOddSelectionMode,
                acceptPriceChanges,
                eachWayMode,
                freeBet,
                stake,
                quickBet,
                multipleOptions,
                events: {
                    [eventId]: bet
                }
            };
            store.dispatch(Config.main.enableUkBetslip ? UkBetslipPlaceBet(betData) : BetslipPlaceBet(betData));
            return next(action);
        }
        default:
            return next(action);

    }
};

export default betSlipUpdateHandler;